import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FirmCollaboratorActions } from '@app/core/state/firm-collaborators/firm-collaborators.actions';
import { BlFrontendButtonComponent } from '@app/core/wrappers/bl-frontend-button.component';
import { DialogResult } from '@app/shared/components/form-dialog-base/form-dialog-base.component';
import { TranslocoModule } from '@jsverse/transloco';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableFormDialogBaseComponent } from 'src/app/core/i18n/translatable-form-dialog-base.component';

interface FirmCollaboratorDialogData {
  clientId: number;
}

const TRANSLATIONS_SCOPE = 'addFirmCollaboratorDialogComponent';

@Component({
  template: `<ng-container *transloco="let t; prefix: scope">
    <input type="text" class="form-control" [placeholder]="t('firmKeyPlaceholder')" [(ngModel)]="firmKey" />
    <div class="flex justify-end mt-6 gap-2">
      <bl-frontend-button
        [text]="'shared.cancel' | transloco"
        variant="secondary"
        (click)="close(null)"></bl-frontend-button>
      <bl-frontend-button
        [text]="'shared.add' | transloco"
        [disabled]="!firmKey"
        (click)="addFirmCollaborator()"></bl-frontend-button></div
  ></ng-container>`,
  standalone: true,
  providers: [getTranslationProvider(TRANSLATIONS_SCOPE)],
  imports: [CommonModule, FormsModule, BlFrontendButtonComponent, TranslocoModule],
})
export class AddFirmCollaboratorDialogComponent extends TranslatableFormDialogBaseComponent<
  FirmCollaboratorDialogData,
  DialogResult
> {
  firmKey: string;
  private currentClientId: number;

  constructor(dialogRef: DynamicDialogRef, config: DynamicDialogConfig<FirmCollaboratorDialogData>) {
    super(dialogRef, config);

    this.currentClientId = config.data.clientId;
  }

  protected static override getTranslationScope(): string {
    return TRANSLATIONS_SCOPE;
  }

  protected static override getDialogConfig(translations: Record<string, string>) {
    return {
      header: translations.addFirmCollaborator,
      width: '600px',
    };
  }

  addFirmCollaborator() {
    this.store.dispatch(
      FirmCollaboratorActions.addFirmCollaborator({
        clientId: this.currentClientId,
        firmKey: this.firmKey,
      }),
    );
    this.close(null);
  }
}
